import request from "@/http/request";

import {
  getPlanList,
  getSessionList,
  getWaitConfirmCount,
  getConfirmList,
  confirmSessionVersion,
  unConfirmSessionVersion,
  downloadSessionVersion,
  downloadGetLogList
} from '@/http/api';
 

export const getPlanListApi = (data) => {
  return request({
      url: getPlanList,
      data,
  })
}

export const getSessionListApi = (data) => {
  return request({
      url: getSessionList,
      data,
  })
}

export const getWaitConfirmCountApi = (data) => {
  return request({
      url: getWaitConfirmCount,
      data,
  })
}

export const getConfirmListApi = (data) => {
  return request({
      url: getConfirmList,
      data,
  })
}

export const confirmSessionVersionApi = (data) => {
  return request({
      url: confirmSessionVersion,
      data,
  })
}

export const unConfirmSessionVersionApi = (data) => {
  return request({
      url: unConfirmSessionVersion,
      data,
  })
}

export const downloadSessionVersionApi = (data) => {
  return request({
      url: downloadSessionVersion,
      data,
  })
}

export const downloadGetLogListApi = (data) => {
  return request({
      url: downloadGetLogList,
      data,
  })
}

